"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTxnActionWatcher = exports.getAccountOnUpdateTransactionSuccess = exports.getTransactionsActionSuccessWatcher = exports.deleteTagActionWatcher = exports.updateTransactionCategoriesForPayeeActionWatcher = exports.autoCategorizeTransactionsActionWatcher = exports.updatePayeeListSuccessActionWatcher = exports.getTransactionsSuccessActionWatcher = exports.transactionActionFailureWatcher = exports.performTransactionAction = exports.triggerAutoCategorize = exports.storePayload = exports.updateTransactionCategoriesForPayee = exports.autoCategorizeTransactions = void 0;
const effects_1 = require("redux-saga/effects");
const core_1 = require("companion-app-components/flux/core");
const core_2 = require("companion-app-components/utils/core");
const bump_1 = require("companion-app-components/flux/bump");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accounts_1 = require("companion-app-components/flux/accounts");
const tags_1 = require("companion-app-components/flux/tags");
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const preProcess_1 = require("companion-app-components/flux/transactions-processing/preProcess");
const actions_1 = require("data/payees/actions");
const selectors_1 = require("data/payees/selectors");
const utils_1 = require("data/transactions/utils");
const transactionsActions = __importStar(require("data/transactions/actions"));
const selectors_2 = require("./selectors");
const log = (0, core_2.getLogger)('transactions/sagas');
// ====================================================
// AUTOCATEGORIZE TRANSACTIONS
//
// reviews recently retrieved transactions and looks for uncategorized transactions that have a match in the
// payee list, and will automatically categorize using the provided suggestion
//
function* autoCategorizeTransactions(action) {
    const featureFlags = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    if (!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.get('autoCategorizeUncategorized'))) {
        return;
    }
    const { payload: txnsToCheck } = action;
    const payeeList = yield (0, effects_1.select)(selectors_1.getPayeesForAccounts, { accountIds: null });
    let txnsToUpdate = txnsToCheck.map((txn) => { var _a; return ((0, utils_1.isUncategorizedTxn)(txn) && txn.payee && payeeList.get((_a = txn.payee) === null || _a === void 0 ? void 0 : _a.toLowerCase())) ? txn : null; });
    // @ts-expect-error - FIXME: Expected 2 arguments, but got 1
    txnsToUpdate = txnsToUpdate.filter((txn) => (txn !== null && !accounts_1.accountsUtils.isLoanAccountFromId(txn.accountId)));
    txnsToUpdate = txnsToUpdate.map((txn) => {
        var _a;
        const payeeEntry = payeeList.get((_a = txn.payee) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        if (payeeEntry && !transactions_1.transactionsUtils.isSplitTxn(payeeEntry.txn) && !transactions_1.transactionsUtils.isTransferTxn(payeeEntry.txn)) {
            return txn.set('coa', payeeEntry.txn.coa).set('split', payeeEntry.txn.split);
        }
        return null;
    });
    txnsToUpdate = txnsToUpdate.filter((txn) => txn !== null);
    // @ts-expect-error - FIXME: Expected at least 2 arguments, but got 1
    const txnsByAccountId = yield (0, effects_1.select)(selectors_2.getTransactionsByAccountId);
    log.debug('Auto categorizing transactions pre ', txnsToUpdate);
    const txnPack = (0, preProcess_1.preProcessUpdate)({
        txns: txnsToUpdate,
        txnsByAccountId,
        featureFlags,
    });
    log.debug('Auto categorizing transactions ', txnPack);
    if (txnPack.allTxnsToUpdate && txnPack.allTxnsToUpdate.length > 0) {
        yield (0, effects_1.put)(transactions_1.transactionsActions.batchTransactions(txnPack.allTxnsToUpdate));
    }
}
exports.autoCategorizeTransactions = autoCategorizeTransactions;
// ====================================================
// UPDATE TRANSACTION CATEGORIES FOR PAYEE
//
// reviews recently retrieved transactions and looks for uncategorized transactions that have a match in the
// payee list, and will automatically categorize using the provided suggestion
function* updateTransactionCategoriesForPayee(action) {
    const { coa, payee, priorCoa } = action.payload;
    // @ts-expect-error - FIXME: Expected 1 arguments, but got 2.
    const transactionsById = yield (0, effects_1.select)(selectors_2.getTransactionsById, {});
    let txnsToUpdate = transactionsById.filter((txn) => (txn.payee === payee) && chart_of_accounts_1.chartOfAccountsUtils.coasAreEqual(txn.coa, priorCoa));
    txnsToUpdate = txnsToUpdate.map((txn) => txn.set('coa', coa));
    // @ts-expect-error - FIXME: Expected at least 2 arguments, but got 1
    const txnsByAccountId = yield (0, effects_1.select)(selectors_2.getTransactionsByAccountId);
    const featureFlags = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    const txnPack = (0, preProcess_1.preProcessUpdate)({
        txns: txnsToUpdate,
        txnsByAccountId,
        featureFlags,
    });
    log.debug('Updating Transaction Categories by Payee ', txnPack);
    if (txnPack.allTxnsToUpdate && txnPack.allTxnsToUpdate.length > 0) {
        yield (0, effects_1.put)(transactions_1.transactionsActions.batchTransactions(txnPack.allTxnsToUpdate, { context: 'register', undo: { userMessage: 'Transaction(s) updated.' } }));
    }
}
exports.updateTransactionCategoriesForPayee = updateTransactionCategoriesForPayee;
//---------------------------------------------------
let lastGetTransactionsPayloads = [];
function* storePayload(data) {
    log.debug('Store Payload', data);
    lastGetTransactionsPayloads = lastGetTransactionsPayloads.concat(data.payload.resources);
}
exports.storePayload = storePayload;
function* triggerAutoCategorize() {
    if (lastGetTransactionsPayloads.length > 0) {
        yield (0, effects_1.put)(transactionsActions.autoCategorizeTransactions(lastGetTransactionsPayloads));
        lastGetTransactionsPayloads = [];
    }
}
exports.triggerAutoCategorize = triggerAutoCategorize;
//---------------------------------------------------
// ====================================================
// PERFORM TRANSACTION ACTION
// a saga for utilizing the transactions/{id}/action or transactions/{id}/action/{otherId}
// pass in an action api object
//
// {
//   id: txnId to impact
//   action: 'ACCEPT' || 'SKIP' || 'MATCH' || 'UNMATCH'   See QCS Documentation for updates
//   otherId: if two IDs are involved in action (e.g. match)
// }
//
function* performTransactionAction(actionData) {
    const config = core_1.resourceStoreTypes.mkQcsSyncResourceConfig({
        resourceName: 'transaction action',
        resourceBaseUrl: (action) => { var _a; return `/transactions/${action.payload.id}/${(_a = action.payload.action) === null || _a === void 0 ? void 0 : _a.toLowerCase()}${action.payload.otherId ? `/${action.payload.otherId}` : ''}`; },
        successAction: transactions_1.transactionsActions.performTransactionActionSuccess,
        failureAction: transactions_1.transactionsActions.performTransactionActionFailure,
        getLastSyncDate: () => null,
        transformResourceToRequestData: (resource) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { id, orderId, action } = resource, other = __rest(resource, ["id", "orderId", "action"]);
            return Object.assign({}, other);
        },
    });
    yield (0, effects_1.call)((core_1.resourceSagaUtils.qcsSyncUpdateResource), config, actionData);
}
exports.performTransactionAction = performTransactionAction;
// =================================================================================================
// Bump Updaters
// =================================================================================================
function* bumpDumpUpdater(resources) {
    const process = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlag, 'bumpProcessTxnUpdates');
    if (process) {
        yield (0, effects_1.put)(transactions_1.transactionsActions.applyTransactionsChanges(transactions_1.transactionsTransformers.transformQcsTransactionsToTransactions(resources), { context: 'BUMP_CHANGE_DUMP' }));
    }
}
function* bumpNudgeUpdater() {
    const process = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlag, 'bumpProcessTxnUpdates');
    if (process) {
        yield (0, effects_1.put)(transactions_1.transactionsActions.getTransactions(undefined, { context: 'BUMP_CHANGE_NUDGE' }));
    }
}
(0, bump_1.subscribeForBumpUpdates)('transactions', (resources) => bumpDumpUpdater(resources), () => bumpNudgeUpdater());
// ====================================================
// ACTION WATCHERS to trigger SAGAS calls
function* ReportActionFailure(actionData) {
    var _a, _b, _c, _d, _e, _f, _g;
    // eslint-disable-next-line no-unsafe-optional-chaining
    const { response, request } = actionData === null || actionData === void 0 ? void 0 : actionData.payload;
    if (response && request) {
        if ((response.status === 400) && (((_a = /match/.exec(request === null || request === void 0 ? void 0 : request.responseURL)) === null || _a === void 0 ? void 0 : _a[0]) === 'match')) {
            const firstId = (_b = /(\d+)(?=\/match\/)/.exec(request === null || request === void 0 ? void 0 : request.responseURL)) === null || _b === void 0 ? void 0 : _b[0];
            const secondId = (_c = /\/match\/(\d+)/.exec(request === null || request === void 0 ? void 0 : request.responseURL)) === null || _c === void 0 ? void 0 : _c[1];
            // @ts-expect-error - FIXME: Property 'set' does not exist on type 'SelectEffect'.ts(2339)
            const firstTxn = yield (_e = (_d = (0, effects_1.select)(selectors_2.getTransactionById, firstId)) === null || _d === void 0 ? void 0 : _d.set) === null || _e === void 0 ? void 0 : _e.call(_d, 'memo', null);
            // @ts-expect-error - FIXME: Property 'set' does not exist on type 'SelectEffect'.ts(2339)
            const secondTxn = yield (_g = (_f = (0, effects_1.select)(selectors_2.getTransactionById, secondId)) === null || _f === void 0 ? void 0 : _f.set) === null || _g === void 0 ? void 0 : _g.call(_f, 'memo', null);
            const firstAccount = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountById, firstTxn === null || firstTxn === void 0 ? void 0 : firstTxn.accountId);
            const secondAccount = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountById, secondTxn === null || secondTxn === void 0 ? void 0 : secondTxn.accountId);
            core_2.crashReporterInterface.reportError(Error('Match Failed! (details)'), (event) => {
                var _a, _b, _c, _d;
                return event.addMetadata('custom', {
                    description: 'ID is deleted?',
                    txn1: ((_a = firstTxn === null || firstTxn === void 0 ? void 0 : firstTxn.toJS) === null || _a === void 0 ? void 0 : _a.call(firstTxn)) || null,
                    txn2: ((_b = secondTxn === null || secondTxn === void 0 ? void 0 : secondTxn.toJS) === null || _b === void 0 ? void 0 : _b.call(secondTxn)) || null,
                    account1: ((_c = firstAccount === null || firstAccount === void 0 ? void 0 : firstAccount.toJS) === null || _c === void 0 ? void 0 : _c.call(firstAccount)) || null,
                    account2: ((_d = secondAccount === null || secondAccount === void 0 ? void 0 : secondAccount.toJS) === null || _d === void 0 ? void 0 : _d.call(secondAccount)) || null,
                });
            });
        }
    }
}
function* transactionActionFailureWatcher() {
    yield (0, effects_1.takeEvery)(transactions_1.transactionsActions.performTransactionActionFailure, ReportActionFailure);
}
exports.transactionActionFailureWatcher = transactionActionFailureWatcher;
function* getTransactionsSuccessActionWatcher() {
    yield (0, effects_1.takeLatest)([
        transactions_1.transactionsActions.getTransactionsSuccess,
    ], storePayload);
}
exports.getTransactionsSuccessActionWatcher = getTransactionsSuccessActionWatcher;
function* updatePayeeListSuccessActionWatcher() {
    yield (0, effects_1.takeLatest)([
        actions_1.updatePayeeListSuccess,
    ], triggerAutoCategorize);
}
exports.updatePayeeListSuccessActionWatcher = updatePayeeListSuccessActionWatcher;
function* autoCategorizeTransactionsActionWatcher() {
    yield (0, effects_1.takeLatest)(transactionsActions.autoCategorizeTransactions, autoCategorizeTransactions);
}
exports.autoCategorizeTransactionsActionWatcher = autoCategorizeTransactionsActionWatcher;
function* updateTransactionCategoriesForPayeeActionWatcher() {
    yield (0, effects_1.takeLatest)(transactionsActions.updateTransactionCategoriesForPayeeAction, updateTransactionCategoriesForPayee);
}
exports.updateTransactionCategoriesForPayeeActionWatcher = updateTransactionCategoriesForPayeeActionWatcher;
function* deleteTagActionWatcher() {
    yield (0, effects_1.takeEvery)(tags_1.tagsActions.deleteTag, function* deleteTag(action) {
        var _a, _b, _c;
        // @ts-expect-error - Property 'txns' does not exist on type 'Meta<BaseResource, any>'
        if ((_b = (_a = action.meta) === null || _a === void 0 ? void 0 : _a.txns) === null || _b === void 0 ? void 0 : _b.size) {
            // @ts-expect-error - Property 'txns' does not exist on type 'Meta<BaseResource, any>'
            yield (0, effects_1.put)(transactions_1.transactionsActions.batchTransactions((_c = action.meta) === null || _c === void 0 ? void 0 : _c.txns));
        }
    });
}
exports.deleteTagActionWatcher = deleteTagActionWatcher;
// check if the action was for a schedule txns instance get ScheduleTxn for QCS
function* handleSchTransPending(load) {
    var _a;
    if ((load === null || load === void 0 ? void 0 : load.payload) && ((_a = load.payload[0]) === null || _a === void 0 ? void 0 : _a.stModelId)) {
        yield (0, effects_1.put)(scheduled_transactions_1.scheduledTransactionsActions.getScheduledTransactions());
    }
}
// action watcher to handle action on sechduled transaction instance(Transaction)
function* getTransactionsActionSuccessWatcher() {
    yield (0, effects_1.takeLatest)(transactions_1.transactionsActions.performTransactionActionSuccess, handleSchTransPending);
}
exports.getTransactionsActionSuccessWatcher = getTransactionsActionSuccessWatcher;
function* getAccountOnUpdateTransactionSuccess(action) {
    const { payload } = action;
    const hasMissingBalance = Array.isArray(payload)
        ? payload.some((txn) => !txn.balance)
        : !(payload === null || payload === void 0 ? void 0 : payload.balance);
    if (hasMissingBalance) {
        yield (0, effects_1.put)(accounts_1.accountsActions.getAccounts());
    }
}
exports.getAccountOnUpdateTransactionSuccess = getAccountOnUpdateTransactionSuccess;
function* updateTxnActionWatcher() {
    yield (0, effects_1.takeEvery)([transactions_1.transactionsActions.updateTransactionSuccess, transactions_1.transactionsActions.batchTransactionsSuccess], getAccountOnUpdateTransactionSuccess);
}
exports.updateTxnActionWatcher = updateTxnActionWatcher;
// ====================================================
// EXPORTS
exports.default = [
    autoCategorizeTransactionsActionWatcher,
    updatePayeeListSuccessActionWatcher,
    updateTransactionCategoriesForPayeeActionWatcher,
    getTransactionsSuccessActionWatcher,
    getTransactionsActionSuccessWatcher,
    deleteTagActionWatcher,
    transactionActionFailureWatcher,
    updateTxnActionWatcher,
];
